import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const getHomeData = async (params: object) => {
  return await GET({
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    url: Api.getHomeData,
    params,
    showError: false
  })
}
export const getAwardData = async (params: object) => {
  return await GET({
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    url: Api.getAwardData,
    params,
    showError: false
  })
}
export const getShareData = async (params: object) => {
  return await GET({
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    url: Api.getShareData,
    params,
    showError: false
  })
}
